import {
  deleteEducation,
  deleteFile,
  getCollege,
  getDesignationsList,
  getFunctionsList,
  getIndustryList,
  getListOfCity,
  getListOfCountries,
  getListOfSkills,
  getListOfState,
  getSkillList,
  getStudentData,
  searchAPI,
  updateCurrentState,
  updateCvDetails,
  updateStatusPending,
  updateStudentData,
  updateUserProfile,
} from 'modules/Onboarding/actions'
import Register from 'modules/Onboarding/Register/index'
import selectors from 'modules/Onboarding/selectors'
import { getCorporateList, getPendingData } from 'modules/Resume/actions'
import { connect } from 'react-redux'
import { getCities } from '../../Resume/actions'

const mapStateToProps = state => ({
  studentData: selectors.getStudentDetails(state),
  studentDetails: selectors.getStudentEditData(state),
  instituteDeatils: selectors.getCampuDetails(state),
  countryList: selectors.getCountryList(state),
  stateList: selectors.getStateList(state),
  listOfSkills: selectors.getListOfSkills(state),
  pendingData: state.resumeData?.pendingData,
})

const mapDispatchToProps = {
  getStudentData,
  updateStudentData,
  deleteFile,
  deleteEducation,
  getCollege,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  getListOfSkills,
  getFunctionsList,
  getDesignationsList,
  getIndustryList,
  updateCurrentState,
  updateStatusPending,
  getSkillList,
  updateCvDetails,
  getCorporateList,
  searchAPI,
  updateUserProfile,
  getCities,
  getPendingData,
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
